__turbopack_context__.v({
  "dropdowns": "C_uNEa_dropdowns",
});
